var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgShow = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 487 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7,0c23.6,0,42.7,19.1,42.7,42.7v426.6c0,23.6-19.1,42.7-42.7,42.7S0,492.9,0,469.3V42.7C0.1,19.1,19.2,0,42.7,0z M167.3,213.4h174c0.1,0,0.1-0.1,0-0.1L286.9,159c-16.5-16.5-17.5-43.3-1.5-60.2c16.6-17.5,44.2-17.8,61.2-0.8l127.9,127.9 c16.7,16.7,16.7,43.8,0,60.5L346.6,414.2c-16.7,16.7-43.7,16.7-60.4,0l0,0c-16.7-16.7-16.7-43.7,0-60.4l54.9-54.9v-0.1 c-58-0.1-115.9-0.1-174-0.2c-21.6,0-39.1-17.6-39.1-39.2v-6.7C128,231,145.5,213.4,167.3,213.4z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Show.41b345b11fad85ca0655bb06c16d12a8.svg";